import styles from './AdLabel.module.scss'

const AdLabel = () => (
  <div className={styles.container} data-cy="ad-label">
    <div className={styles.label} data-cy="ad-label_label">
      Anzeige
    </div>
    <hr />
  </div>
)

export default AdLabel
